import { useEffect } from "react";

const TeacherRedirect = () => {
  useEffect(() => {
    window.location.href = import.meta.env.VITE_ACADEMIC_BASE_URL + "/teachers";
  }, []);
  return null;
};

export const teacherRoutes = [
    { path: "/dashboard/teachers", element: <TeacherRedirect /> },
    { path: "/dashboard/teachers/new", element: <TeacherRedirect /> },
    { path: "/dashboard/teachers/:teacherId", element: <TeacherRedirect /> },
    { path: "/dashboard/teachers/:id/update", element: <TeacherRedirect /> },
    { path: "*", element: <TeacherRedirect /> },
];

export const TeacherRouteWrapper = ({ children }) => <>{children}</>;
